import * as React from 'react';
import { Icon } from '@grandvisionhq/icons';

const IconLinkWithFallback = ({ url , labels , hasLink =false , icon  })=>/*#__PURE__*/ React.createElement("div", {
        className: "link-item"
    }, hasLink ? /*#__PURE__*/ React.createElement("a", {
        className: "link-item__link",
        href: url
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: icon !== null && icon !== void 0 ? icon : 'folded-page-with-text'
    }), /*#__PURE__*/ React.createElement("span", null, labels.linkCaption)) : /*#__PURE__*/ React.createElement("p", {
        className: "link-item__label"
    }, labels.fallback))
;

export { IconLinkWithFallback };
//# sourceMappingURL=IconLinkWithFallback.js.map
